import { render, staticRenderFns } from "./FacebookLogoBase64.vue?vue&type=template&id=3a2fe116&scoped=true"
import script from "./FacebookLogoBase64.vue?vue&type=script&lang=js"
export * from "./FacebookLogoBase64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2fe116",
  null
  
)

export default component.exports